export interface Funds_Interface {
  id:number,
  code:string
  dsc:string
  price:number,
  price_date:String,
  price_user:String,
  subdate:String,
  username:String,
  del:boolean,
}

export function Empty_Funds_Interface(){
  return{
    id:0,
    code:'',
    dsc:'',
    price:0,
    price_date:'',
    price_user:'',
    subdate:'',
    username:'',
    del:false,
  }
}
